import { BrandColors } from "@/constants/theme";
import { Dimensions, StyleSheet } from "react-native";

const { width, height } = Dimensions.get("window");

export const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "#000000",
  },
  image: {
    width: width,
    height: "100%",
    resizeMode: "cover",
  },
  gradientOverlay: {
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
    height: height * 0.55,
    justifyContent: "flex-end",
  },
  bottomSheet: {
    paddingHorizontal: 24,
    paddingBottom: 30,
    gap: 32,
  },
  textContainer: {
    alignItems: "flex-start",
    gap: 12,
  },
  stepBadge: {
    paddingHorizontal: 12,
    paddingVertical: 6,
    borderRadius: 20,
    borderWidth: 1,
    borderColor: "rgba(255,255,255,0.3)",
    backgroundColor: "rgba(0,0,0,0.35)",
  },
  stepBadgeText: {
    fontSize: 14,
    fontWeight: "500",
    color: "#fff",
  },
  title: {
    fontSize: 32,
    fontWeight: "700",
    color: "#fff",
    lineHeight: 38,
  },
  subtitle: {
    fontSize: 16,
    fontWeight: "400",
    color: "rgba(255,255,255,0.9)",
    lineHeight: 24,
  },
  pagination: {
    flexDirection: "row",
    alignItems: "center",
    gap: 8,
    marginTop: 4,
  },
  dot: {
    width: 8,
    height: 8,
    borderRadius: 4,
    borderWidth: 1,
    borderColor: "rgba(255,255,255,0.4)",
    backgroundColor: "transparent",
  },
  activeDot: {
    backgroundColor: BrandColors.primary,
    borderColor: BrandColors.primary,
  },
  navRow: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 16,
  },
  navRowAlone: {
    justifyContent: "flex-end",
  },
  backButton: {
    width: 48,
    height: 48,
    borderRadius: 24,
    borderWidth: 1,
    borderColor: "rgba(255,255,255,0.5)",
    alignItems: "center",
    justifyContent: "center",
  },
  nextButton: {
    backgroundColor: "#fff",
    paddingVertical: 16,
    paddingHorizontal: 40,
    borderRadius: 32,
    alignItems: "center",
    justifyContent: "center",
    minWidth: width * 0.32,
  },
  buttonText: {
    color: "#000",
    fontSize: 16,
    fontWeight: "700",
  },
});
